import React from "react";


interface Branding {
    label: string;
    abbreviation: string;
    logoUrl: string;
    backgroundUrl: string;
    registrationUrl: string;
    clientId: string | null;
    privacyUrl: string;
    termsUrl: string;
    appStoreUrl: string | null;
    playStoreUrl: string | null;
    eulaUrl: string;
    paymentTC: string;
    paymentFAQ: string;
    refundPolicyUrl: string;
}

export const BrandingContext = React.createContext<Branding>({
    label: "HabitNu",
    abbreviation: "HabitNu",
    backgroundUrl: "/images/web-background.jpg",
    logoUrl: "/images/habitnu/logo.png",
    registrationUrl: "https://habitnu.com",
    clientId: null,
    privacyUrl: "/privacy-policy",
    termsUrl: "/terms-of-use",
    appStoreUrl: null,
    playStoreUrl: null,
    eulaUrl: "https://www.habitnu.com/eula",
    paymentTC: "",
    paymentFAQ: "",
    refundPolicyUrl: "",
});
